import { valid, refreshToken, ajax, serviceAjax, header } from './base'
import config from '../../config'

const system = {
  async GetGrantedPermission(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/GetGrantedPermission',
      type: 'get',
      data
    })
    return response
  },
  // 字典
  async GetDictionaryList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  async GetDictionaryForSelect(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/GetDictionaryForSelect',
      type: 'get',
      data
    })
    return response
  },
  async AddOrUpdateDictionary(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/CreateOrUpdate',
      type: 'post',
      data
    })
    return response
  },
  async DelDictionary(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/Delete',
      type: 'post',
      data
    })
    return response
  },
  async ActiveDictionary(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetDictionary(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Dictionary/GetById',
      type: 'get',
      data
    })
    return response
  },
  // 地址
  async GetAddressList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Address/GetPaged',
      type: 'post',
      data
    })
    return response
  },
  // 账号
  async GetUserList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/GetAll',
      type: 'post',
      data
    })
    return response
  },
  async AddUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/Update',
      type: 'post',
      data
    })
    return response
  },
  async DelUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/Delete',
      type: 'post',
      data
    })
    return response
  },
  async UserSet(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/SetUser',
      type: 'post',
      data
    })
    return response
  },
  async ActiveUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/IsActiveOpt',
      type: 'post',
      data
    })
    return response
  },
  async GetUser(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/Get',
      type: 'get',
      data
    })
    return response
  },
  async GetRoles(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/GetRoles',
      type: 'get',
      data
    })
    return response
  },
  async ResetPassword(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/User/ResetPassword',
      type: 'post',
      data
    })
    return response
  },
  async GetAllDealerGroup(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/DealerGroup/GetAllDealerGroupData',
      type: 'get',
      data
    })
    return response
  },
  //  角色
  async GetRoleList(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/GetAll',
      type: 'post',
      data
    })
    return response
  },
  async AddRole(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/Create',
      type: 'post',
      data
    })
    return response
  },
  async UpdateRole(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/Update',
      type: 'post',
      data
    })
    return response
  },
  async DelRole(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/Delete',
      type: 'post',
      data
    })
    return response
  },
  async GetRole(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/Get',
      type: 'get',
      data
    })
    return response
  },
  async GetRoleForEdit(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/GetRoleForEdit',
      type: 'get',
      data
    })
    return response
  },
  async GetAllPermissions(data = {}) {
    const response = await serviceAjax({
      url: '/api/services/app/Role/GetAllPermissions',
      type: 'get',
      data
    })
    return response
  },

  
}
export default system



// WEBPACK FOOTER //
// ./src/common/api/system.js